import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// POST: Creates a Manager or User for a company - protected route
async function httpCreateManagerOrUser(user) {
  const token = Auth.getToken();
  return await fetch(`${API_URL}/companies/create-manager-or-user`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(user),
  });
}
// POST: Sends the welcome email to the user
async function httpEmployeeSignupEmail(email, password, companyId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/send-signup-email`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      email,
      password,
      companyId,
    }),
  });
}

// POST: Login manager of the company
async function httpLoginManager(user) {
  return await fetch(`${API_URL}/companies/login`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(user),
  });
}

// POST: Creates forms for the company
async function httpCreateForms(companyId, formData) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/create-forms/${companyId}`, {
    method: 'post',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: formData,
  });
}

// POST: Creates a subcontractor for the company
async function httpCreateSubcontractor(companyId, subcontractor) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/create-subcontractor/${companyId}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(subcontractor),
  });
}

// POST: Creates a company
async function httpCreateCompany(company, user) {
  try {
    return await fetch(`${API_URL}/companies/create-company`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ company, user }),
    });
  } catch (err) {
    return err;
  }
}

// POST: Resend account details to the user
async function httpResendAccountDetails(email, password, userId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/resend-account-details`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      email,
      password,
      userId,
    }),
  });
}

export {
  httpCreateManagerOrUser,
  httpEmployeeSignupEmail,
  httpLoginManager,
  httpCreateForms,
  httpCreateSubcontractor,
  httpCreateCompany,
  httpResendAccountDetails,
};
